"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Title["default"];
  }
});
var _Title = _interopRequireDefault(require("./Title"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }